import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[#F7F8FA] -skew-y-2 transform origin-top-left"></div>
      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6 max-w-3xl mx-auto">
              {t('trafficPro.finalTitle')}
            </h2>
            <p className="text-foreground-600 text-base md:text-lg mb-10 max-w-2xl mx-auto">
              {t('trafficPro.finalSubtitle')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="https://wa.link/em25v1"
                className="px-8 py-4 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-[0_4px_16px_rgba(200,30,30,0.25)] hover:shadow-[0_6px_24px_rgba(200,30,30,0.35)] hover:-translate-y-0.5"
              >
                {t('trafficPro.ctaPrimary')}
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="https://wa.link/em25v1"
                className="px-8 py-4 rounded-full border-2 border-[#25D366] text-[#25D366] text-sm font-semibold hover:bg-[#25D366] hover:text-white transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                {t('trafficPro.ctaWhatsApp')}
              </Link>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}